import { Component, DestroyRef, inject } from '@angular/core';

import { CanvasConfettiService } from '@recruitee/common';
import { I18nService } from '@recruitee/i18n';
import { OfferStatus } from '@recruitee/offers-types';
import {
  ButtonComponent,
  DialogBodyComponent,
  DialogComponentI,
  DialogFooterComponent,
  DialogRef,
  HeadingComponent,
} from '@recruitee/user-interface';

type FirstJobPublishedDialogData = {
  status: OfferStatus.Internal | OfferStatus.Published;
};

@Component({
  selector: 'rt-first-job-published-dialog',
  standalone: true,
  imports: [DialogBodyComponent, DialogFooterComponent, HeadingComponent, ButtonComponent],
  templateUrl: './first-job-published-dialog.component.html',
  styleUrl: './first-job-published-dialog.component.less',
})
export class FirstJobPublishedDialogComponent
  implements DialogComponentI<FirstJobPublishedDialogData, boolean>
{
  private readonly i18n = inject(I18nService);
  private readonly dialogRef = inject(DialogRef);
  private readonly canvasConfettiService = inject(CanvasConfettiService);
  private readonly destroyRef = inject(DestroyRef);

  public readonly translations = {
    heading: this.i18n.translate('app.offers.first_job_published_dialog.heading'),
    description: this.i18n.translate('app.offers.first_job_published_dialog.description'),
    cancel: this.i18n.translate('app.common.cancel'),
    promoteJob: this.i18n.translate('app.offers.first_job_published_dialog.promote_job'),
    viewJobsPipeline: this.i18n.translate(
      'app.offers.first_job_published_dialog.view_jobs_pipeline',
    ),
  };
  public readonly imageSrc = 'assets/images/offers/first-job-published.svg';

  public status: OfferStatus.Internal | OfferStatus.Published;

  private stopConfetti: () => void;
  private unregisterDestroy = this.destroyRef.onDestroy(() => this.stopConfetti());

  public get isInternalJob(): boolean {
    return this.status === OfferStatus.Internal;
  }

  public ngOnInit(): void {
    this.stopConfetti = this.canvasConfettiService.fireworks();
  }

  public setDialogData(data: FirstJobPublishedDialogData): void {
    this.status = data.status;
  }

  public close(): void {
    this.dialogRef.close(false);
  }

  public onCtaButtonClick(): void {
    this.dialogRef.close(true);
  }
}
